export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-lg text-white"></i>
              </div>
              <span className="text-lg font-heading">农民影视</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              免费高清影视在线观看平台，提供高清电影免费看与电视剧免费全集资源，高清流畅播放体验，即点即播无需等待。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/10 hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/10 hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/10 hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading text-white mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {[
                { label: '焦点专题', href: '#carousel' },
                { label: '热门排行', href: '#ranking' },
                { label: '最新动态', href: '#updates' },
                { label: '精彩视频', href: '#media' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading text-white mb-4">内容分类</h3>
            <ul className="space-y-2.5">
              {['高清电影', '电视剧全集', '热门综艺', '动漫动画', '纪录片频道'].map((cat) => (
                <li key={cat}>
                  <a
                    href="#cards"
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer"
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading text-white mb-4">合作伙伴</h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              更多合作伙伴陆续加入中，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 农民影视 nmtv.fun 版权所有 | 免费高清影视在线观看不缓冲
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-400 cursor-pointer hover:text-white transition-colors">用户协议</span>
            <span className="text-xs text-foreground-400 cursor-pointer hover:text-white transition-colors">隐私政策</span>
            <span className="text-xs text-foreground-400 cursor-pointer hover:text-white transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}